// extracted by mini-css-extract-plugin
module.exports = {"iconSvg":"Icons_iconSvg__21z-y"};